import React, { useEffect, useState, useRef } from 'react';
import appconfig from '../appConfig'
import { AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { GetCounts } from '../services/dashboard.service'
import { tokenRequest } from "../auth/authConfig";
import TopMyFiles from '../feature/dashboard/top-my-files';
import TopAssignedFiles from '../feature/dashboard/top-assigned-files';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthorization } from '../hooks/useAuthorization';
import { Grid } from '@mui/material';
import InfoCard from '../components/Card';
import TopFilesToBeAssigned from '../feature/dashboard/top-files-to-be-assigned';
import Backdrop from '../components/elements/Loader';
import {device} from '../utils/deviceBreakpoints';

function Home() {

  const [canCreate, canRead, canUpdate, canDelete] = useAuthorization();
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [myFileCount, setMyFileCount] = useState(0);
  const [myFileNavigation, setMyFileNavigation] = useState("/myfiles");
  const [filesToAssign, setFilesToAssign] = useState(0);
  const [assignedFiles, setAssignedFiles] = useState(0);
  const [hasMyFilesPermission, setHasMyFilesPermission] = useState(false);
  const [hasFilesToBeAssignedPermission, setHasFilesToBeAssignedPermission] = useState(false);
  const [hasAssignedFilesPermission, setHasAssignedFilesPermission] = useState(false);
  const [isClickedMyfiles, setIsClickedMyfiles] = useState(false);
  const [isClickedFilestoAssign, setIsClickedFilestoAssign] = useState(false);
  const [isClickedAssignedFiles, setIsClickedAssignedFiles] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [cardKey, setCardKey] = useState(searchParams.get("cardKey") ? searchParams.get("cardKey") : "1");
  const navigate = useNavigate();
  const apiServerUrl = appconfig.API_SERVER_URL;
  const [isDataReady, setIsDataReady] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setIsDataReady(true); 
    } else {
      setIsDataReady(false); 
    }
    setInitialPermissions();
  }, [account, instance, isAuthenticated]);

  useEffect(() => {
    function handleSelect(card1: boolean, card2: boolean, card3: boolean) {
      setIsClickedMyfiles(card1);
      setIsClickedFilestoAssign(card2);
      setIsClickedAssignedFiles(card3);
    };
    if (cardKey == "1") {
      handleSelect(true, false, false);
    } else if (cardKey == "2") {
      handleSelect(false, true, false);
    } else if (cardKey == "3") {
      handleSelect(false, false, true);
    }
  }, [cardKey]);

  function LoadInitialData() {
    if (account) {
      instance.acquireTokenSilent(
        tokenRequest
      ).then((response) => {
        if (response) {
          setInitialTopCountData(response.accessToken).then(async () => {
            setInitialBottomData(response.accessToken);
          }).then(() => {setIsDataReady(true)});
        }
      });
    }
  }

  const setInitialPermissions = () => {
    var userHasPermission = false;
    if (account && account.idTokenClaims && account.idTokenClaims.roles
      && (account.idTokenClaims.roles[0].toString() == "DutyCounselTriageLead"
        || account.idTokenClaims.roles[0].toString() == "LegalServicesManager"
        || account.idTokenClaims.roles[0].toString() === "RosterEnhancedAccess")) {
      
      userHasPermission = true;

      if (account.idTokenClaims.roles[0].toString() !== "RosterEnhancedAccess") {
        setHasFilesToBeAssignedPermission(userHasPermission);
        setHasAssignedFilesPermission(userHasPermission);
      }

      setHasMyFilesPermission(userHasPermission);
      if (!searchParams.get("cardKey"))
        setCardKey("1");
    }
    else if (account && account.idTokenClaims && account.idTokenClaims.roles
      && account.idTokenClaims.roles[0].toString() == "LegalAdministrativeAssisstant") {
      userHasPermission = true;
      setHasAssignedFilesPermission(userHasPermission);
      setHasFilesToBeAssignedPermission(false);
      setHasMyFilesPermission(false);
      if (!searchParams.get("cardKey"))
        setCardKey("3");
    } else if (account && account.idTokenClaims && account.idTokenClaims.roles
      && account.idTokenClaims.roles[0].toString() == "SystemAdministrator") {
        setIsDataReady(true);
    }
    else {
      const lawyers: string[] = appconfig.LAWYER_ROLE_NAMES.split(";");

      lawyers.forEach(roleValue => {
        if (account && account.idTokenClaims && account.idTokenClaims.roles
          && account.idTokenClaims.roles[0].toString() == roleValue) {
          userHasPermission = true;
          setHasMyFilesPermission(userHasPermission);
          setHasAssignedFilesPermission(false);
          setHasFilesToBeAssignedPermission(false);
          if (!searchParams.get("cardKey"))
            setCardKey("1");
        }
      });
    }
    if (userHasPermission) {
      LoadInitialData();
    }
  }

  const setInitialTopCountData = async (token: string) => {

    await GetCounts(token).then((countDetails) => {

      countDetails.forEach((element: any) => {
        if (element.myFilesCount) {
          setMyFileCount(element.myFilesCount);

          if (element.value == 0 && account && account.idTokenClaims && account.idTokenClaims.roles &&
            (account.idTokenClaims.roles[0].toString() == "DutyCounselTriageLead"
              || account.idTokenClaims.roles[0].toString() == "LegalServicesManager"
              || account.idTokenClaims.roles[0].toString() == "RosterEnhancedAccess")) {
            setHasMyFilesPermission(false);
            setCardKey("2");
          }

        }
        if (element.assignedFilesCount) {
          setAssignedFiles(element.assignedFilesCount)
        }
        if (element.filesToBeAssignedCount) {
          setFilesToAssign(element.filesToBeAssignedCount);
        }

      });

    });

  }

  const setInitialBottomData = async (token: string) => {
    if (hasMyFilesPermission) {
      setCardKey("1");
    }
    else if (hasFilesToBeAssignedPermission) {
      setCardKey("2");
    }
    else if (hasAssignedFilesPermission) {
      setCardKey("3");
    }
  }


  if (isDataReady) {
    return (
    <>
    <Grid item xs={12} md={12} style={{ minHeight: "100vh",background: "#F0F0F0 0% 0% no-repeat padding-box" }}>
      {isAuthenticated && (
        <Grid container direction="row" alignItems="flex-start" style={{
          padding: "0px 20px 0px 20px"
        }} >
          <Grid item xs={12} md={12} sx={{textAlign: "left",letterSpacing: "0px", color: " #000000", opacity: "1", margin: "20px 10px 20px 10px",
          [`@media ${device.mobileS}`] : {
            font: "normal normal bold 17px/19px Franklin Gothic Medium"
          },
          [`@media ${device.mobileM}`] : {
            font: "normal normal bold 19px/22px Franklin Gothic Medium"
          },
          [`@media ${device.mobileL}`] : {
            font: "normal normal bold 22px/25px Franklin Gothic Medium"
          },
          [`@media ${device.tablet}`]  :{
            font: "normal normal bold 26px/29px Franklin Gothic Medium"
          },
          [`@media ${device.laptop}`] : {
            font: "normal normal bold 32px/37px Franklin Gothic Medium"
          }
          }}>Dashboards</Grid>

          {hasMyFilesPermission &&
            <Grid item xs={12} sm={6} md={4} style={{ padding: "5px" }}>
              <InfoCard setKey={setCardKey} cardID="1" title="My Files" subtitle="" count={myFileCount} isClicked={isClickedMyfiles} />
            </Grid>
          }
          {hasFilesToBeAssignedPermission &&
            <Grid item xs={12} sm={6}  md={4} style={{ padding: "5px" }}>
              <InfoCard setKey={setCardKey} cardID="2" title="Files to Assign" subtitle="" count={filesToAssign} isClicked={isClickedFilestoAssign} />
            </Grid>
          } {hasAssignedFilesPermission &&
            <Grid item xs={12} sm={6} md={4} style={{ padding: "5px" }}>
              <InfoCard setKey={setCardKey} cardID="3" title="Assigned Files" subtitle="" count={assignedFiles} isClicked={isClickedAssignedFiles} />
            </Grid>
          }
          {hasMyFilesPermission && cardKey === "1" &&
            <>
              <Grid item xs={12} md={12} sx={{textAlign: "left", letterSpacing: "0px", color: " #000000", opacity: "1", margin: "20px 10px 10px 10px",
                    [`@media ${device.mobileS}`] : {
                      font: "normal normal bold 15px/17px Franklin Gothic Medium"
                    },
                    [`@media ${device.mobileM}`] : {
                      font: "normal normal bold 16px/19px Franklin Gothic Medium"
                    },
                    [`@media ${device.mobileL}`] : {
                      font: "normal normal bold 18px/21px Franklin Gothic Medium"
                    },
                    [`@media ${device.tablet}`]  :{
                      font: "normal normal bold 20px/23px Franklin Gothic Medium"
                    },
                    [`@media ${device.laptop}`] : {
                      font: "normal normal bold 24px/29px Franklin Gothic Medium"
                    }
              }}>My Files</Grid>
              <Grid item xs={12} md={12} style={{ padding: "10px 5px" }}><TopMyFiles totalCount={myFileCount}></TopMyFiles> </Grid>
            </>}
          {hasFilesToBeAssignedPermission && cardKey === "2" &&
            <>
              <Grid item xs={12} md={12} sx={{textAlign: "left", letterSpacing: "0px", color: " #000000", opacity: "1", margin: "20px 10px 10px 10px",
                    [`@media ${device.mobileS}`] : {
                      font: "normal normal bold 15px/17px Franklin Gothic Medium"
                    },
                    [`@media ${device.mobileM}`] : {
                      font: "normal normal bold 16px/19px Franklin Gothic Medium"
                    },
                    [`@media ${device.mobileL}`] : {
                      font: "normal normal bold 18px/21px Franklin Gothic Medium"
                    },
                    [`@media ${device.tablet}`]  :{
                      font: "normal normal bold 20px/23px Franklin Gothic Medium"
                    },
                    [`@media ${device.laptop}`] : {
                      font: "normal normal bold 24px/29px Franklin Gothic Medium"
                    }
              }}>Files to Assign</Grid>
              <Grid item xs={12} md={12} style={{ padding: "10px 5px" }}><TopFilesToBeAssigned totalCount={filesToAssign}></TopFilesToBeAssigned> </Grid>
            </>}
          {hasAssignedFilesPermission && cardKey === "3" &&
            <>
              <Grid item xs={12} md={12} sx={{textAlign: "left", letterSpacing: "0px", color: " #000000", opacity: "1", margin: "20px 10px 10px 10px",
                    [`@media ${device.mobileS}`] : {
                      font: "normal normal bold 15px/17px Franklin Gothic Medium"
                    },
                    [`@media ${device.mobileM}`] : {
                      font: "normal normal bold 16px/19px Franklin Gothic Medium"
                    },
                    [`@media ${device.mobileL}`] : {
                      font: "normal normal bold 18px/21px Franklin Gothic Medium"
                    },
                    [`@media ${device.tablet}`]  :{
                      font: "normal normal bold 20px/23px Franklin Gothic Medium"
                    },
                    [`@media ${device.laptop}`] : {
                      font: "normal normal bold 24px/29px Franklin Gothic Medium"
                    }
              }}>Assigned Files</Grid>
              <Grid item xs={12} md={12} style={{ padding: "10px 5px" }}><TopAssignedFiles totalCount={assignedFiles}/> </Grid>
            </>}
        </Grid>)}
        </Grid>
    </>

    )
  } else {
    return (
      <Backdrop />
    );
  }
}

export default Home;